import { render, staticRenderFns } from "./assignment-intervention.vue?vue&type=template&id=2eeaed35"
import script from "./assignment-intervention.vue?vue&type=script&lang=js"
export * from "./assignment-intervention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports